const Index = () => import('@/pages/website/IndexPage.vue');
const HomePage = () => import('@/pages/website/HomePage.vue');
const About = () => import('@/pages/website/AboutPage.vue');
const Login = () => import('@/pages/website/LoginPage.vue');
const Signup = () => import('@/pages/website/SignupPage.vue');
// const MapPage = () => import('@/pages/website/MapPage.vue');
// const FieldPage = () => import('@/pages/website/FieldPage.vue');
// const FieldsListPage = () => import('@/pages/website/FieldsListPage.vue');

const routes = [
  {
    path: '/',
    name: 'home',
    components: {
      default: HomePage,
    },
  },
  {
    path: '/agendar',
    name: 'index',
    components: {
      default: Index,
    },
  },
  {
    path: '/index',
    name: 'index2',
    components: {
      default: Index,
    },
  },
  {
    path: '/about',
    name: 'about',
    components: {
      default: About,
    },
  },
  {
    path: '/login',
    name: 'login',
    components: {
      default: Login,
    },
  },
  {
    path: '/signup',
    name: 'signup',
    components: {
      default: Signup,
    },
  },
  // {
  //   path: '/map',
  //   redirect: { name: 'map' },
  // },
  // {
  //   path: '/map2',
  //   redirect: { name: 'map' },
  // },
  // {
  //   path: '/canchas',
  //   name: 'fields-list',
  //   components: {
  //     default: FieldsListPage,
  //   },
  // },
  // {
  //   path: '/canchas/:slug',
  //   name: 'field-show',
  //   components: {
  //     default: FieldPage,
  //   },
  //   props: { default: true },
  // },
  // {
  //   path: '/:slug',
  //   name: 'professional-profile',
  //   components: {
  //     default: () => import('@/pages/website/ProfessionalProfilePage.vue'),
  //   },
  // },
];

export default routes;
